// extracted by mini-css-extract-plugin
export default {"button":"applicant-modal_button__7QjeJ","test":"applicant-modal_test__+eN63","modal":"applicant-modal_modal__oxUW4"};